import {
    HomePageRoute,
    ContactPageRoute,
    ProfilePageRoute,
    ArticlePageRoute,
    CartPageRoute,
    ShopPageRoute,
    FavouritesPageRoute,
    CatalogPageRoute,
    HistoryOfOrdersPageRoute,
    DeliveryOrderPageRoute,
    CreatingUserFizicheskoyeLitsoPageRoute,
    CreatingUserYuridicheskoyeLitsoPageRoute,
    CrmPageRoute,
    OrdersPageRoute,
    OrderPagePageRoute,
    InvoicePageRoute,
    ClientsListPageRoute,
    ClientDetailsPageRoute,
    AddClientModalPageRoute,
    DriversComponentPageRoute,
    VehiclesPageRoute,
    DeliveryAreasComponentPageRoute,
    ChatPageRoute,
    SettingsPageRoute,
    CreateContractPageRoute,
    ContractDetailsPageRoute,
    ProductionPageRoute,
    ApplicationsPageRoute,
    LogisticsPageRoute,
    ArchiveOrdersPageRoute,
    WaybillPageRoute,
    TrackSheetPageRoute,
    LostOrdersPageRoute,
    OrdersOnDeliveryPageRoute,
    WeeklyOrdersPageRoute,
    ApplyPageRoute,
    MyOrdersPageRoute,
    MyContractsPageRoute,
    OrganizationDetailsPageRoute,
    AdminPanelPageRoute,
    CreateUserPagePageRoute,
    CreateProductPagePageRoute,
    UserListPageRoute,
    UserProfilePageRoute,
    ProductListPageRoute,
    ProductProfilePageRoute,
    PaymentStatusPageRoute,
    TransportListPageRoute,
    TransportProfilePageRoute,
    CreateTransportPageRoute,
    AdminClientsListPageRoute,
    CreateContractAdminPageRoute,
    ContractsListAdminPageRoute,
    CreateClientAdminPageRoute,
    EditClientAdminPageRoute,
    OrganizationsListPageRoute,
    DivisionsListPageRoute,
    RegionsListPageRoute,
    DriversListPageRoute,
} from './consts';

import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ProfilePage from './pages/ProfilePage';
import ArticlePage from './pages/ArticlePage';
import Cart from './components/store/Cart';
import Shop from './components/store/Main';
import Favourites from './components/store/Favourites';
import Catalog from './components/store/Catalog';
import HistoryOfOrders from './components/store/HistoryOfOrders';
import DeliveryOrder from './components/store/DeliveryOrder';
import CreatingUserFizicheskoyeLitso from './components/store/CreatingUserFizicheskoyeLitso';
import CreatingUserYuridicheskoyeLitso from './components/store/CreatingUserYuridicheskoyeLitso';
import Crm from './components/crm/Header&SIdebar/workspace';
import Orders from './components/crm/Header&SIdebar/orders';
import OrderPage from './components/crm/Header&SIdebar/orderpage';
import Invoice from './components/crm/Header&SIdebar/invoice';
import ClientsList from './components/crm/Header&SIdebar/ClientsList';
import ClientDetails from './components/crm/Header&SIdebar/ClientDetails';
import AddClientModal from './components/crm/Header&SIdebar/AddClientModal';
import DriversComponent from './components/crm/Reference.books/DriversComponent';
import Vehicles from './components/crm/Reference.books/Vehicles';
import Chat from './components/crm/Header&SIdebar/Chat';
import Settings from './components/crm/Header&SIdebar/settings';
import CreateContract from './components/crm/Header&SIdebar/CreateContract';
import ContractDetails from './components/crm/Header&SIdebar/ContractDetails';
import Production from './components/crm/Header&SIdebar/Production';
import Applications from './components/crm/Header&SIdebar/Applications';
import Logistics from './components/crm/Header&SIdebar/Logistics';
import ArchiveOrders from './components/crm/Header&SIdebar/ArchiveOrders';
import Waybill from './components/crm/Header&SIdebar/Waybill';
import TrackSheet from './components/crm/Header&SIdebar/TrackSheet';
import LostOrders from './components/crm/Header&SIdebar/LostOrders';
import OrdersOnDelivery from './components/crm/Header&SIdebar/OrdersOnDelivery';
import WeeklyOrders from './components/crm/Header&SIdebar/WeeklyOrders';
import Apply from './components/crm/Header&SIdebar/Apply';
import MyOrders from './components/crm/Header&SIdebar/MyOrders';
import MyContracts from './components/crm/Header&SIdebar/MyContracts';
import OrganizationDetails from './components/crm/Header&SIdebar/OrganizationDetails';
import PaymentStatus from './components/crm/Header&SIdebar/PaymentStatus';
import AdminPanel from './components/admin/HomePage';
import CreateUserPage from './components/admin/CreateUserPage';
import CreateProductPage from './components/admin/CreateProductPage';
import UserList from './components/admin/UserList';
import UserProfile from './components/admin/UserProfile';
import ProductList from './components/admin/ProductList';
import ProductProfile from './components/admin/ProductProfile';
import TransportList from './components/admin/TransportList';
import TransportProfile from './components/admin/TransportProfile'
import CreateTransportPage from './components/admin/CreateTransportPage';
import ClientsListAdmin from './components/admin/ClientListAdmin'; 
import CreateContractAdmin from './components/admin/CreateContractAdmin';
import ContractsListAdmin from './components/admin/ContractListAdmin';
import DeliveryAreasComponent from './components/admin/DeliveryAreasComponent';
import CreateClientPage from './components/admin/CreateClientPage';
import EditClientPage from './components/admin/EditClientAdminPage';
import OrganizationsList from './components/admin/OrganizationsList';
import DivisionsList from './components/admin/DivisionsList';
import RegionsList from './components/admin/RegionsList';
import DriversList from './components/admin/DriversList';

export const adminRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },


    // Магазин (Store)
    {
        path: CartPageRoute,
        Component: Cart // Корзина
    },
    {
        path: FavouritesPageRoute,
        Component: Favourites // Избранное
    },
    {
        path: CatalogPageRoute,
        Component: Catalog // Каталог
    },
    {
        path: HistoryOfOrdersPageRoute,
        Component: HistoryOfOrders // История заказов
    },
    {
        path: DeliveryOrderPageRoute,
        Component: DeliveryOrder // Заказ на доставку
    },
    {
        path: CreatingUserFizicheskoyeLitsoPageRoute,
        Component: CreatingUserFizicheskoyeLitso // Создание пользователя - физическое лицо
    },
    {
        path: CreatingUserYuridicheskoyeLitsoPageRoute,
        Component: CreatingUserYuridicheskoyeLitso // Создание пользователя - юридическое лицо
    },

    // CRM
    {
        path: CrmPageRoute,
        Component: Crm // CRM
    },
    {
        path: OrdersPageRoute,
        Component: Orders // Заказы
    },
    {
        path: OrderPagePageRoute,
        Component: OrderPage // Страница заказа
    },
    {
        path: InvoicePageRoute,
        Component: Invoice // Страница счёта
    },
    {
        path: ClientsListPageRoute,
        Component: ClientsList // Список клиентов
    },
    {
        path: ClientDetailsPageRoute,
        Component: ClientDetails // Детали по клиенту
    },
    {
        path: AddClientModalPageRoute,
        Component: AddClientModal // Модальное окно добавления клиента
    },
    {
        path: DriversComponentPageRoute,
        Component: DriversComponent // Компонент водителей
    },
    {
        path: VehiclesPageRoute,
        Component: Vehicles // Транспортные средства
    },
    {
        path: ChatPageRoute,
        Component: Chat // Чат
    },
    {
        path: SettingsPageRoute,
        Component: Settings // Настройки
    },
    {
        path: CreateContractPageRoute,
        Component: CreateContractAdmin 
    },
    {
        path: ContractDetailsPageRoute,
        Component: ContractDetails // Детали контракта
    },
    {
        path: ProductionPageRoute,
        Component: Production // Производство
    },
    {
        path: ApplicationsPageRoute,
        Component: Applications // Приложения
    },
    {
        path: LogisticsPageRoute,
        Component: Logistics // Логистика
    },
    {
        path: ArchiveOrdersPageRoute,
        Component: ArchiveOrders // Архив заказов
    },
    {
        path: WaybillPageRoute,
        Component: Waybill // Путевые листы
    },
    {
        path: TrackSheetPageRoute,
        Component: TrackSheet // Путевой лист (track_sheet)
    },
    {
        path: LostOrdersPageRoute,
        Component: LostOrders // Невыполненые заказы
    },
    {
        path: OrdersOnDeliveryPageRoute,
        Component: OrdersOnDelivery // Заказы на доставке
    },
    {
        path: WeeklyOrdersPageRoute,
        Component: WeeklyOrders // Еженедельные заказы
    },
    {
        path: ApplyPageRoute,
        Component: Apply // Применить
    },
    {
        path: MyOrdersPageRoute,
        Component: MyOrders // Мои заказы
    },
    {
        path: MyContractsPageRoute,
        Component: MyContracts // Мои контракты
    },
    {
        path: OrganizationDetailsPageRoute,
        Component: OrganizationDetails // Детали организации
    },
    {
        path: PaymentStatusPageRoute,
        Component: PaymentStatus // Заказы
    },

    // Админ панель
    {
        path: AdminPanelPageRoute,
        Component: AdminPanel // Административная панель
    },
    {
        path: CreateUserPagePageRoute,
        Component: CreateUserPage // Создание пользователя
    },
    {
        path: CreateProductPagePageRoute,
        Component: CreateProductPage // Создание продукта
    },
    {
        path: UserListPageRoute,
        Component: UserList // Список пользователей
    },
    {
        path: UserProfilePageRoute,
        Component: UserProfile // Профиль пользователя
    },
    {
        path: ProductListPageRoute,
        Component: ProductList // Список продуктов
    },
    {
        path: ProductProfilePageRoute,
        Component: ProductProfile // Профиль продукта
    },
    {
        path: TransportListPageRoute,
        Component: TransportList
    },
    {
        path: TransportProfilePageRoute,
        Component: TransportProfile
    },
    {
        path: CreateTransportPageRoute,
        Component: CreateTransportPage
    },
    {
        path: AdminClientsListPageRoute,
        Component: ClientsListAdmin
    },
    {
        path: CreateContractAdminPageRoute,
        Component: CreateContractAdmin
    },
    {
        path: ContractsListAdminPageRoute,
        Component: ContractsListAdmin
    },
    {
        path: DeliveryAreasComponentPageRoute,
        Component: DeliveryAreasComponent // Компонент областей доставки
    },
    {
        path: CreateClientAdminPageRoute,
        Component: CreateClientPage
    },
    {
        path: EditClientAdminPageRoute,
        Component: EditClientPage
    },

    // Справочники
    {
        path: OrganizationsListPageRoute,
        Component: OrganizationsList
    },
    {
        path: DivisionsListPageRoute,
        Component: DivisionsList
    },
    {
        path: RegionsListPageRoute,
        Component: RegionsList
    },
    {
        path: DriversListPageRoute,
        Component: DriversList
    },
];

export const operatorRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },

    // Магазин (Store)
    {
        path: CartPageRoute,
        Component: Cart // Корзина
    },
    {
        path: FavouritesPageRoute,
        Component: Favourites // Избранное
    },
    {
        path: CatalogPageRoute,
        Component: Catalog // Каталог
    },
    {
        path: HistoryOfOrdersPageRoute,
        Component: HistoryOfOrders // История заказов
    },
    {
        path: DeliveryOrderPageRoute,
        Component: DeliveryOrder // Заказ на доставку
    },
    {
        path: CreatingUserFizicheskoyeLitsoPageRoute,
        Component: CreatingUserFizicheskoyeLitso // Создание пользователя - физическое лицо
    },
    {
        path: CreatingUserYuridicheskoyeLitsoPageRoute,
        Component: CreatingUserYuridicheskoyeLitso // Создание пользователя - юридическое лицо
    },

    // CRM
    {
        path: CrmPageRoute,
        Component: Crm // CRM
    },
    {
        path: OrdersPageRoute,
        Component: Orders // Заказы
    },
    {
        path: OrderPagePageRoute,
        Component: OrderPage // Страница заказа
    },
    {
        path: InvoicePageRoute,
        Component: Invoice // Страница счёта
    },
    {
        path: ClientsListPageRoute,
        Component: ClientsList // Список клиентов
    },
    {
        path: AddClientModalPageRoute,
        Component: AddClientModal // Модальное окно добавления клиента
    },
    {
        path: DriversComponentPageRoute,
        Component: DriversComponent // Компонент водителей
    },
    {
        path: VehiclesPageRoute,
        Component: Vehicles // Транспортные средства
    },
    {
        path: ChatPageRoute,
        Component: Chat // Чат
    },
    {
        path: SettingsPageRoute,
        Component: Settings // Настройки
    },
    {
        path: CreateContractPageRoute,
        Component: CreateContract // Создание контракта
    },
    {
        path: ContractDetailsPageRoute,
        Component: ContractDetails // Детали контракта
    },
    {
        path: ProductionPageRoute,
        Component: Production // Производство
    },
    {
        path: ApplicationsPageRoute,
        Component: Applications // Приложения
    },
    {
        path: LogisticsPageRoute,
        Component: Logistics // Логистика
    },
    {
        path: ArchiveOrdersPageRoute,
        Component: ArchiveOrders // Архив заказов
    },
    {
        path: WaybillPageRoute,
        Component: Waybill // Путевые листы
    },
    {
        path: TrackSheetPageRoute,
        Component: TrackSheet // Путевой лист (track_sheet)
    },
    {
        path: LostOrdersPageRoute,
        Component: LostOrders // Невыполненые заказы
    },
    {
        path: OrdersOnDeliveryPageRoute,
        Component: OrdersOnDelivery // Заказы на доставке
    },
    {
        path: WeeklyOrdersPageRoute,
        Component: WeeklyOrders // Еженедельные заказы
    },
    {
        path: ApplyPageRoute,
        Component: Apply // Применить
    },
    {
        path: MyOrdersPageRoute,
        Component: MyOrders // Мои заказы
    },
    {
        path: MyContractsPageRoute,
        Component: MyContracts // Мои контракты
    },
    {
        path: OrganizationDetailsPageRoute,
        Component: OrganizationDetails // Детали организации
    },
    {
        path: PaymentStatusPageRoute,
        Component: PaymentStatus // Заказы
    },

    // Админ панель
    {
        path: AdminPanelPageRoute,
        Component: AdminPanel // Административная панель
    },
    {
        path: CreateUserPagePageRoute,
        Component: CreateUserPage // Создание пользователя
    },
    {
        path: CreateProductPagePageRoute,
        Component: CreateProductPage // Создание продукта
    },
    {
        path: UserListPageRoute,
        Component: UserList // Список пользователей
    },
    {
        path: UserProfilePageRoute,
        Component: UserProfile // Профиль пользователя
    },
    {
        path: ProductListPageRoute,
        Component: ProductList // Список продуктов
    },
    {
        path: ProductProfilePageRoute,
        Component: ProductProfile // Профиль продукта
    },

];

export const publicRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },

    // Магазин (Store)
    {
        path: CartPageRoute,
        Component: Cart // Корзина
    },
    {
        path: ShopPageRoute,
        Component: Shop // Shop
    },
    {
        path: FavouritesPageRoute,
        Component: Favourites // Избранное
    },
    {
        path: CatalogPageRoute,
        Component: Catalog // Каталог
    },
    {
        path: HistoryOfOrdersPageRoute,
        Component: HistoryOfOrders // История заказов
    },
    {
        path: DeliveryOrderPageRoute,
        Component: DeliveryOrder // Заказ на доставку
    },
    {
        path: CreatingUserFizicheskoyeLitsoPageRoute,
        Component: CreatingUserFizicheskoyeLitso // Создание пользователя - физическое лицо
    },
    {
        path: CreatingUserYuridicheskoyeLitsoPageRoute,
        Component: CreatingUserYuridicheskoyeLitso // Создание пользователя - юридическое лицо
    },

    //CRM
    // {
    //     path: CrmPageRoute,
    //     Component: Crm // CRM
    // },
    // {
    //     path: OrdersPageRoute,
    //     Component: Orders // Заказы
    // },
    // {
    //     path: OrderPagePageRoute,
    //     Component: OrderPage // Страница заказа
    // },
    // {
    //     path: InvoicePageRoute,
    //     Component: Invoice // Страница счёта
    // },
    // {
    //     path: ClientsListPageRoute,
    //     Component: ClientsList // Список клиентов
    // },
    // {
    //     path: ClientDetailsPageRoute,
    //     Component: ClientDetails // Список клиентов
    // },
    // {
    //     path: AddClientModalPageRoute,
    //     Component: AddClientModal // Модальное окно добавления клиента
    // },
    // {
    //     path: DriversComponentPageRoute,
    //     Component: DriversComponent // Компонент водителей
    // },
    // {
    //     path: VehiclesPageRoute,
    //     Component: Vehicles // Транспортные средства
    // },
    // {
    //     path: DeliveryAreasComponentPageRoute,
    //     Component: DeliveryAreasComponent // Компонент областей доставки
    // },
    // {
    //     path: ChatPageRoute,
    //     Component: Chat // Чат
    // },
    // {
    //     path: SettingsPageRoute,
    //     Component: Settings // Настройки
    // },
    // {
    //     path: CreateContractPageRoute,
    //     Component: CreateContract // Создание контракта
    // },
    // {
    //     path: ContractDetailsPageRoute,
    //     Component: ContractDetails // Детали контракта
    // },
    // {
    //     path: ProductionPageRoute,
    //     Component: Production // Производство
    // },
    // {
    //     path: ApplicationsPageRoute,
    //     Component: Applications // Приложения
    // },
    // {
    //     path: LogisticsPageRoute,
    //     Component: Logistics // Логистика
    // },
    // {
    //     path: ArchiveOrdersPageRoute,
    //     Component: ArchiveOrders // Архив заказов
    // },
    // {
    //     path: OrdersOnDeliveryPageRoute,
    //     Component: OrdersOnDelivery // Заказы на доставке
    // },
    // {
    //     path: WeeklyOrdersPageRoute,
    //     Component: WeeklyOrders // Еженедельные заказы
    // },
    // {
    //     path: ApplyPageRoute,
    //     Component: Apply // Применить
    // },
    // {
    //     path: MyOrdersPageRoute,
    //     Component: MyOrders // Мои заказы
    // },
    // {
    //     path: MyContractsPageRoute,
    //     Component: MyContracts // Мои контракты
    // },
    // {
    //     path: OrganizationDetailsPageRoute,
    //     Component: OrganizationDetails // Детали организации
    // },
    // {
    //     path: PaymentStatusPageRoute,
    //     Component: PaymentStatus // Заказы
    // },

    // Админ панель
    // {
    //     path: AdminPanelPageRoute,
    //     Component: AdminPanel // Административная панель
    // },
    // {
    //     path: CreateUserPagePageRoute,
    //     Component: CreateUserPage // Создание пользователя
    // },
    // {
    //     path: CreateProductPagePageRoute,
    //     Component: CreateProductPage // Создание продукта
    // },
    // {
    //     path: UserListPageRoute,
    //     Component: UserList // Список пользователей
    // },
    // {
    //     path: UserProfilePageRoute,
    //     Component: UserProfile // Профиль пользователя
    // },
    // {
    //     path: ProductListPageRoute,
    //     Component: ProductList // Список продуктов
    // },
    // {
    //     path: ProductProfilePageRoute,
    //     Component: ProductProfile // Профиль продукта
    // },
];

export const userRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },

    // CRM для клиента — только «свой» периметр
    {
        path: ChatPageRoute,
        Component: Chat // Чат
    },
    {
        path: SettingsPageRoute,
        Component: Settings // Настройки
    },
    {
        path: ContractDetailsPageRoute,
        Component: ContractDetails // Детали договора (только своего)
    },
    {
        path: ApplyPageRoute,
        Component: Apply // Подать заявку
    },
    {
        path: MyOrdersPageRoute,
        Component: MyOrders // Мои заявки
    },
    {
        path: MyContractsPageRoute,
        Component: MyContracts // Мои договоры
    },
];

export const logistRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },

    // Магазин (Store)
    {
        path: CartPageRoute,
        Component: Cart // Корзина
    },
    {
        path: FavouritesPageRoute,
        Component: Favourites // Избранное
    },
    {
        path: CatalogPageRoute,
        Component: Catalog // Каталог
    },
    {
        path: HistoryOfOrdersPageRoute,
        Component: HistoryOfOrders // История заказов
    },
    {
        path: DeliveryOrderPageRoute,
        Component: DeliveryOrder // Заказ на доставку
    },
    {
        path: CreatingUserFizicheskoyeLitsoPageRoute,
        Component: CreatingUserFizicheskoyeLitso // Создание пользователя - физическое лицо
    },
    {
        path: CreatingUserYuridicheskoyeLitsoPageRoute,
        Component: CreatingUserYuridicheskoyeLitso // Создание пользователя - юридическое лицо
    },

    // CRM
    {
        path: CrmPageRoute,
        Component: Crm // CRM
    },
    {
        path: OrdersPageRoute,
        Component: Orders // Заказы
    },
    {
        path: OrderPagePageRoute,
        Component: OrderPage // Страница заказа
    },
    {
        path: InvoicePageRoute,
        Component: Invoice // Страница счёта
    },
    {
        path: ClientsListPageRoute,
        Component: ClientsList // Список клиентов
    },
    {
        path: AddClientModalPageRoute,
        Component: AddClientModal // Модальное окно добавления клиента
    },
    {
        path: DriversComponentPageRoute,
        Component: DriversComponent // Компонент водителей
    },
    {
        path: VehiclesPageRoute,
        Component: Vehicles // Транспортные средства
    },
    {
        path: ChatPageRoute,
        Component: Chat // Чат
    },
    {
        path: SettingsPageRoute,
        Component: Settings // Настройки
    },
    {
        path: CreateContractPageRoute,
        Component: CreateContract // Создание контракта
    },
    {
        path: ContractDetailsPageRoute,
        Component: ContractDetails // Детали контракта
    },
    {
        path: ProductionPageRoute,
        Component: Production // Производство
    },
    {
        path: ApplicationsPageRoute,
        Component: Applications // Приложения
    },
    {
        path: LogisticsPageRoute,
        Component: Logistics // Логистика
    },
    {
        path: ArchiveOrdersPageRoute,
        Component: ArchiveOrders // Архив заказов
    },
    {
        path: WaybillPageRoute,
        Component: Waybill // Путевые листы
    },
    {
        path: TrackSheetPageRoute,
        Component: TrackSheet // Путевой лист (track_sheet)
    },
    {
        path: OrdersOnDeliveryPageRoute,
        Component: OrdersOnDelivery // Заказы на доставке
    },
    {
        path: WeeklyOrdersPageRoute,
        Component: WeeklyOrders // Еженедельные заказы
    },
    {
        path: ApplyPageRoute,
        Component: Apply // Применить
    },
    {
        path: MyOrdersPageRoute,
        Component: MyOrders // Мои заказы
    },
    {
        path: MyContractsPageRoute,
        Component: MyContracts // Мои контракты
    },
    {
        path: OrganizationDetailsPageRoute,
        Component: OrganizationDetails // Детали организации
    },
    {
        path: PaymentStatusPageRoute,
        Component: PaymentStatus // Заказы
    },

    // Админ панель
    {
        path: AdminPanelPageRoute,
        Component: AdminPanel // Административная панель
    },
    {
        path: CreateUserPagePageRoute,
        Component: CreateUserPage // Создание пользователя
    },
    {
        path: CreateProductPagePageRoute,
        Component: CreateProductPage // Создание продукта
    },
    {
        path: UserListPageRoute,
        Component: UserList // Список пользователей
    },
    {
        path: UserProfilePageRoute,
        Component: UserProfile // Профиль пользователя
    },
    {
        path: ProductListPageRoute,
        Component: ProductList // Список продуктов
    },
    {
        path: ProductProfilePageRoute,
        Component: ProductProfile // Профиль продукта
    },
];

export const prodRoutes = [
    // Сайт (Site)
    {
        path: HomePageRoute,
        Component: HomePage // Главная страница
    },
    {
        path: ContactPageRoute,
        Component: ContactPage // Страница контактов
    },
    {
        path: ProfilePageRoute,
        Component: ProfilePage // Страница профиля
    },
    {
        path: ArticlePageRoute,
        Component: ArticlePage // Страница статьи
    },

    // Магазин (Store)
    {
        path: CartPageRoute,
        Component: Cart // Корзина
    },
    {
        path: FavouritesPageRoute,
        Component: Favourites // Избранное
    },
    {
        path: CatalogPageRoute,
        Component: Catalog // Каталог
    },
    {
        path: HistoryOfOrdersPageRoute,
        Component: HistoryOfOrders // История заказов
    },
    {
        path: DeliveryOrderPageRoute,
        Component: DeliveryOrder // Заказ на доставку
    },
    {
        path: CreatingUserFizicheskoyeLitsoPageRoute,
        Component: CreatingUserFizicheskoyeLitso // Создание пользователя - физическое лицо
    },
    {
        path: CreatingUserYuridicheskoyeLitsoPageRoute,
        Component: CreatingUserYuridicheskoyeLitso // Создание пользователя - юридическое лицо
    },

    // CRM
    {
        path: CrmPageRoute,
        Component: Crm // CRM
    },
    {
        path: OrdersPageRoute,
        Component: Orders // Заказы
    },
    {
        path: OrderPagePageRoute,
        Component: OrderPage // Страница заказа
    },
    {
        path: InvoicePageRoute,
        Component: Invoice // Страница счёта
    },
    {
        path: ClientsListPageRoute,
        Component: ClientsList // Список клиентов
    },
    {
        path: AddClientModalPageRoute,
        Component: AddClientModal // Модальное окно добавления клиента
    },
    {
        path: DriversComponentPageRoute,
        Component: DriversComponent // Компонент водителей
    },
    {
        path: VehiclesPageRoute,
        Component: Vehicles // Транспортные средства
    },
    {
        path: ChatPageRoute,
        Component: Chat // Чат
    },
    {
        path: SettingsPageRoute,
        Component: Settings // Настройки
    },
    {
        path: CreateContractPageRoute,
        Component: CreateContract // Создание контракта
    },
    {
        path: ContractDetailsPageRoute,
        Component: ContractDetails // Детали контракта
    },
    {
        path: ProductionPageRoute,
        Component: Production // Производство
    },
    {
        path: ApplicationsPageRoute,
        Component: Applications // Приложения
    },
    {
        path: LogisticsPageRoute,
        Component: Logistics // Логистика
    },
    {
        path: ArchiveOrdersPageRoute,
        Component: ArchiveOrders // Архив заказов
    },
    {
        path: WaybillPageRoute,
        Component: Waybill // Путевые листы
    },
    {
        path: TrackSheetPageRoute,
        Component: TrackSheet // Путевой лист (track_sheet)
    },
    {
        path: OrdersOnDeliveryPageRoute,
        Component: OrdersOnDelivery // Заказы на доставке
    },
    {
        path: WeeklyOrdersPageRoute,
        Component: WeeklyOrders // Еженедельные заказы
    },
    {
        path: ApplyPageRoute,
        Component: Apply // Применить
    },
    {
        path: MyOrdersPageRoute,
        Component: MyOrders // Мои заказы
    },
    {
        path: MyContractsPageRoute,
        Component: MyContracts // Мои контракты
    },
    {
        path: OrganizationDetailsPageRoute,
        Component: OrganizationDetails // Детали организации
    },
    {
        path: PaymentStatusPageRoute,
        Component: PaymentStatus // Заказы
    },

    // Админ панель
    {
        path: AdminPanelPageRoute,
        Component: AdminPanel // Административная панель
    },
    {
        path: CreateUserPagePageRoute,
        Component: CreateUserPage // Создание пользователя
    },
    {
        path: CreateProductPagePageRoute,
        Component: CreateProductPage // Создание продукта
    },
    {
        path: UserListPageRoute,
        Component: UserList // Список пользователей
    },
    {
        path: UserProfilePageRoute,
        Component: UserProfile // Профиль пользователя
    },
    {
        path: ProductListPageRoute,
        Component: ProductList // Список продуктов
    },
    {
        path: ProductProfilePageRoute,
        Component: ProductProfile // Профиль продукта
    },
    {
        path: TransportListPageRoute,
        Component: TransportList
    },
    {
        path: TransportProfilePageRoute,
        Component: TransportProfile
    },
    {
        path: CreateTransportPageRoute,
        Component: CreateTransportPage
    },

];

export const HIDDEN_ELEMENT_PATHS = [
    '/crm',
    '/Applications',
    '/Apply',
    '/OrganizationDetails',
    '/MyContracts',
    '/MyOrders',
    '/ArchiveOrders',
    '/Waybill',
    '/TrackSheet',
    '/LostOrders',
    '/OrdersOnDelivery',
    '/WeeklyOrders',
    '/logistics',
    '/production',
    '/settings',
    '/orders',
    '/ClientsList',
    '/driversComponent',
    '/vehicles',
    '/DeliveryAreasComponent',
    '/CreateContract',
    '/chat',
    '/PaymentStatus',
    '/AdminPanel',
    '/CreateUserPage',
    '/CreateProductPage',
    '/UserList',
    '/UserProfile',
    '/ProductList',
    '/ProductProfile',
    './products',
    '/TransportList',
    '/TransportProfile',
    '/CreateTransportPage',
    '/Admin/Clients',
    '/Admin/Contracts',
    '/Admin/CreateContract',
    '/Admin/Organizations',
    '/Admin/Divisions',
    '/Admin/Regions',
    '/Admin/Drivers',
    '/ClientsListAdmin',
    '/DeliveryAreasComponent',

  ];